import Axios from '@/network/axios'


// 获取首页信息接口
export const goodsInfo = params => { return Axios.fetchGet('index.php?m=api&c=Index&a=block_index&id=1', params).then(res => res.data) }

// 获取商品详情接口
export const goodsDetail = params => { return Axios.fetchPost('index.php?m=Api&c=Goods&a=goodsInfo', params).then(res => res.data) }

//搜索商品
export const searchGoods = params => { return Axios.fetchGet('index.php?m=api&c=Goods&a=searchs&sort=sales&asc=desc', params).then(res => res.data) }

// 登陆
export const pswLogin = params => { return Axios.fetchPost('index.php?m=Api&c=Publics&a=login', params).then(res => res.data) }

// 发送验证码
export const sendCode = params => { return Axios.fetchGet('index.php?m=Home&c=Api&a=send_validate_code', params).then(res => res.data) }

// 购物车下单cart2信息
export const Cart2 = params => { return Axios.fetchPost('index.php?m=Api&c=Cart&a=cart2', params).then(res => res.data) }

// 购物车下单cart3信息
export const Cart3 = params => { return Axios.fetchPost('index.php?m=Api&c=Cart&a=cart3', params).then(res => res.data) }

// 支付配置
export const setting = params => { return Axios.fetchGet('index.php?m=api&c=Payment&a=payment', params).then(res => res.data) }

// 第三方支付
export const payInfo = params => { return Axios.fetchPost('index.php?m=api&c=Payment&a=unitedPay', params).then(res => res.data) }

// 获取用户地址列表
export const getAddList = params => { return Axios.fetchGet('index.php?m=Api&c=User&a=getAddressList', params).then(res => res.data) }

// 获取省份/城市/区/县
export const getAddress = params => { return Axios.fetchGet('index.php?m=Api&c=index&a=get_region', params).then(res => res.data) }

// 保存编辑/新添加地址
export const editAddress = params => { return Axios.fetchPost('index.php?m=Api&c=User&a=addAddress', params).then(res => res.data) }

// 删除地址
export const delAddress = params => { return Axios.fetchPost('index.php?m=Api&c=User&a=del_address', params).then(res => res.data) }

// 活动页库存
export const activity = params => { return Axios.fetchGet('/index.php?m=api&c=FreeActivity&a=surplusGoodsNum', params).then(res => res.data) }

//活动用户信息提交
export const userInfo = params => { return Axios.fetchPost('/index.php?m=api&c=FreeActivity&a=activityUserInfoHandle', params).then(res => res.data) }
